import { scannerDetailQueryAtom } from '../_graphql/queryScannerDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $scannerSidecarId = settingsRouteParamAtom(
  ['/hardware/scanners/:sidecarId/:scannerId'],
  'sidecarId',
);

export const $scannerId = settingsRouteParamAtom(
  ['/hardware/scanners/:sidecarId/:scannerId'],
  'scannerId',
);

export const $remoteScannerDetail = scannerDetailQueryAtom((get) => {
  const scannerId = get($scannerId);
  return {
    variables: {
      ids: scannerId ? [scannerId] : [],
    },
    skip: !scannerId,
  };
});
